/* ==========================================================================
   Email signup (sections/os-newsletter.liquid): starts the sailboat
   drawing when the section scrolls into view, shows the button as busy
   while the form sends, and sails the boat off after a signup.
   Does nothing for reduced motion, so the boat just shows drawn.
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.oshReady) return;
    root.dataset.oshReady = '1';

    var form = root.querySelector('form');
    var btn = root.querySelector('.osh-nl__btn');
    if (form && btn) form.addEventListener('submit', function () { btn.classList.add('is-loading'); });

    var success = root.querySelector('[data-osh-nl-success]');
    var scene = root.querySelector('.osh-nl__scene');
    if (!scene || reduceMotion || !('IntersectionObserver' in window)) return;

    // Embedded Omnisend form: no page reload after signing up, so watch for
    // its thank-you part to appear and sail the boat off then.
    var embed = root.querySelector('.osh-nl__embed');
    if (embed && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        var done = embed.querySelector('[class*="-success-sections-container"]');
        if (done && done.offsetParent !== null) {
          root.classList.add('is-in', 'is-sent');
          mo.disconnect();
        }
      });
      mo.observe(embed, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }

    // Just signed up: the page reloads at this section, so skip the drawing
    // and go straight to sailing off.
    if (success) {
      root.classList.add('is-in', 'is-sent');
      return;
    }

    root.classList.add('is-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-in');
        io.disconnect();
      });
    }, { threshold: 0.35 });
    io.observe(scene);
  }

  function initAll() { document.querySelectorAll('[data-osh-newsletter]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
